export const DB_TO_LOCAL = { baba: "babysitter", cliente: "family", admin: "admin" };
export const LOCAL_TO_DB = { babysitter: "baba", family: "cliente", familia: "cliente", admin: "admin" };

export const normalizeLocalType = (raw) => {
  const lower = String(raw || "").toLowerCase();
  if (lower === "baba" || lower === "babysitter") return "babysitter";
  if (lower === "cliente" || lower === "family" || lower === "familia") return "family";
  if (lower === "admin") return "admin";
  return null;
};

export const localTypeToDb = (type) => LOCAL_TO_DB[type] ?? "cliente";
export const dbTypeToLocal = (type) => DB_TO_LOCAL[type] ?? null;

export const dashboardRouteFromType = (type) => {
  if (type === "admin") return "/dashboard-admin";
  if (type === "babysitter" || type === "baba") return "/dashboard-baba";
  return "/dashboard-familia";
};
